import React from 'react'

import { AppConfig } from '../../app-config'
import getPackageKeyFromPathname from '../../utils/getPackageKeyFromPathname'

const getCanonicalThemeUrl = ({ theme, pathname, isFromPackages, locale }) => {
	const pathSplitArr = pathname.split('/')
	const region =
		pathSplitArr.length > 2 ? pathSplitArr[pathSplitArr.length - 1] : ''
	if (isFromPackages) {
		if (theme) {
			return (
				<link
					rel="canonical"
					href={`${AppConfig.domain_url}${theme}-packages${
						region ? '/' : ''
					}${region}`}
				/>
			)
		} else
			return (
				<link
					rel="canonical"
					href={`${AppConfig.domain_url}packages${region ? '/' : ''}${region}`}
				/>
			)
	} else {
		const key = getPackageKeyFromPathname(pathname)

		return (
			<link
				rel="canonical"
				href={`${AppConfig.domain_url}${locale}${locale ? '/' : ''}${key}`}
			/>
		)
	}
}

export default getCanonicalThemeUrl
